<template>
  <v-container>
    <div class="pt-4 pb-4">
      <span class="title">Mileage</span>
    </div>

    <v-card>
      <table class="final-table th-no-padding lines-b pointer hover full-width">
        <colgroup ref="colgroup1">
          <col width="10px">
          <col width="10px">
          <col width="10px">
        </colgroup>

        <tr class="unselectable">
            <c-table-header
            title="ID"
            code="id"
            class="sticky"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Name"
            code="name"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>

            <c-table-header
            title="Distance (km)"
            code="distance"
            :filters="filters"
            @onClick="clickSortHeader">
            </c-table-header>
        </tr>

        <journey-row
        v-for="item in paginatedArray" 
        :key="item.tempID"
        :item="item"
        :selected="selected"
        @checkRow="checkRow(item)"
        @click.native="clickRow(item)"
        ></journey-row>
      </table>
    </v-card>

    <v-card class="mt-4">

      <v-row>
        <v-col md="6">
          <v-card class="mr-2">
            <div class="title pa-4">Settings</div>

            <div class="c-hr"></div>

            <div class="pa-4">
              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Total distance:</div>
                </v-col>
                <v-col md="9">
                  <c-select-customer :selectedID.sync="formData.customer_id" class="crx-box-input"></c-select-customer>
                </v-col>
              </v-row>

              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Date:</div>
                </v-col>
                <v-col md="9">
                  <c-datetime :date.sync="formData.date" class="crx-box-input"></c-datetime>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="pa-2">
        <v-btn outlined color="color1" @click="calculate">
          Calculate
        </v-btn>
      </v-row>

    </v-card>
  </v-container>
</template>

<script>
import ListController from '@/mixins/ListController'
import JourneyRow from './journey-row'

export default {
  components: {
    JourneyRow
  },
  mixins: [ListController],
  data () {
    return {
      isLoading: false,
    }
  },
  methods: {
    calculate () {

    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/mileage`)
          .then(response => {
            var rows = response.data.rows
            this.items = rows
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>